import React from 'react';
import './AppModal.css';

const AppModal = ({
  open,
  title,
  description,
  children,
  confirmText = 'Confirmar',
  cancelText = 'Cancelar',
  onConfirm,
  onCancel,
  disableConfirm = false,
  loading = false,
  hideFooter = false,
  variant = 'default',
}) => {
  if (!open) return null;

  const handleBackdropClick = (event) => {
    if (event.target.classList.contains('app-modal__backdrop') && onCancel) {
      onCancel();
    }
  };

  return (
    <div className="app-modal__backdrop" onMouseDown={handleBackdropClick}>
      <div className={`app-modal app-modal--${variant}`} role="dialog" aria-modal="true">
        <div className="app-modal__header">
          <h3>{title || 'Confirmacao'}</h3>
          {onCancel && (
            <button type="button" className="app-modal__close" onClick={onCancel} aria-label="Fechar modal">
              ×
            </button>
          )}
        </div>
        {description && <p className="app-modal__description">{description}</p>}
        <div className="app-modal__body">{children}</div>
        {!hideFooter && (
          <div className="app-modal__footer">
            {onCancel && (
              <button type="button" className="app-modal__btn app-modal__btn--ghost" onClick={onCancel} disabled={loading}>
                {cancelText}
              </button>
            )}
            {onConfirm && (
              <button
                type="button"
                className="app-modal__btn app-modal__btn--primary"
                onClick={onConfirm}
                disabled={disableConfirm || loading}
              >
                {loading ? 'Processando...' : confirmText}
              </button>
            )}
          </div>
        )}
      </div>
    </div>
  );
};

export default AppModal;
